import { render, staticRenderFns } from "./detail-event.html?vue&type=template&id=6a6c2088&scoped=true&"
import script from "./detail-event.js?vue&type=script&lang=js&"
export * from "./detail-event.js?vue&type=script&lang=js&"
import style0 from "./detail-event.css?vue&type=style&index=0&id=6a6c2088&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a6c2088",
  null
  
)

export default component.exports